import { Icon } from '@/components/Icon';
import { haptic, notify } from '@/lib/telegram';
import { ImportantNote, Italic, StepProgress } from './parts';

interface SetupDoneProps {
  onFinish: () => void;
}

export function SetupDone({ onFinish }: SetupDoneProps) {
  return (
    <div
      style={{
        padding: '12px 18px 130px',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <div style={{ marginBottom: 18 }}>
        <StepProgress n={3} style={{ marginBottom: 22 }} />
        <div className="eyebrow" style={{ marginBottom: 10 }}>
          03 / 03 · готово
        </div>
        <h1
          style={{
            fontFamily: "'Instrument Serif', serif",
            fontWeight: 400,
            fontSize: 52,
            lineHeight: 0.95,
            margin: 0,
            color: 'var(--ink)',
            letterSpacing: '-0.02em',
          }}
        >
          всё
          <br />
          <Italic>работает.</Italic>
        </h1>
        <p
          style={{
            fontSize: 14,
            color: 'var(--ink-2)',
            marginTop: 14,
            lineHeight: 1.5,
            maxWidth: 320,
          }}
        >
          открой happ и нажми круглую кнопку включения. инстаграм, ютуб, chatgpt, claude, твиттер —
          как должно было с самого начала
        </p>
      </div>

      <div
        style={{
          flex: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          position: 'relative',
          minHeight: 200,
        }}
      >
        <div
          style={{
            width: 140,
            height: 140,
            borderRadius: 999,
            border: '1.5px solid var(--moss)',
            background: 'var(--moss-soft)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            position: 'relative',
          }}
        >
          <div
            aria-hidden
            style={{
              position: 'absolute',
              inset: -24,
              border: '1px solid var(--paper-3)',
              borderRadius: 999,
            }}
          />
          <div
            aria-hidden
            style={{
              position: 'absolute',
              inset: -48,
              border: '1px solid color-mix(in oklab, var(--paper-3) 50%, transparent)',
              borderRadius: 999,
            }}
          />
          <Icon name="check" size={56} stroke="var(--moss-deep)" sw={1.6} />
        </div>
      </div>

      <ImportantNote icon="shield">
        <span style={{ color: 'var(--ink)' }}>советуем держать happ всегда включённым.</span> если
        интернет вдруг не работает — открой happ и проверь, что vpn активен
      </ImportantNote>

      <button
        onClick={() => {
          haptic('medium');
          notify('success');
          onFinish();
        }}
        className="btn btn-moss"
        style={{ width: '100%', height: 54, fontSize: 14.5 }}
      >
        завершить настройку
        <Icon name="check" size={14} stroke="#fff" sw={2} />
      </button>
    </div>
  );
}
